import React, { useState } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';

const InfoDialogButtons = () => {
    const [showMessage1, setShowMessage1] = useState<boolean>(false);
    const [showMessage2, setShowMessage2] = useState<boolean>(false);
    const [showMessage3, setShowMessage3] = useState<boolean>(false);
    const [showMessage4, setShowMessage4] = useState<boolean>(false);
    const [showMessage5, setShowMessage5] = useState<boolean>(false);
    
    const handleToggleMessage1 = () => {
        setShowMessage1(!showMessage1);
    };
    const handleToggleMessage2 = () => {
        setShowMessage2(!showMessage2);
    };
    const handleToggleMessage3 = () => {
        setShowMessage3(!showMessage3);
    };
    const handleToggleMessage4 = () => {
        setShowMessage4(!showMessage4);
    };
    const handleToggleMessage5 = () => {
        setShowMessage5(!showMessage5);
    };

    return (
    <>
      <Grid container spacing ={2}>
        <Grid item xs={12}>
          {/* Create image Button */}
        <Button onClick={handleToggleMessage1} fullWidth variant="contained" color="primary">
          Tilføj Billeder til Galleriet
        </Button>
          {/* Create image message */}
          {showMessage1 && (
          <>
            <div>
            <ol>
              <li>Klik på "Rediger" i Begivenhedsoversigt.</li>
              <li>Klik på "Tilføj billede" for at åbne et nyt vindue.</li>
              <li>Upload et billede i .jpg eller .png format.</li>
              <li>Sørg for, at billedet overholder størrelseskravene:
                <ul>
                  <li>Ude af drift: 1024 x 768 pixels</li>
                  <li>Pauseskærm: 1024 x 645 pixels</li>
                  <li>Reklame: 1024 x 630 pixels</li>
                </ul>
              </li>
              <li>Vælg billedtypen (Ude af drift, Pauseskærm eller Reklame).</li>
              <li>Klik på "Gem Ændringer".</li>
            </ol>
            </div>
          </>
          )}
        </Grid>

        <Grid item xs={12}>
          {/* change image Button */}
          <Button onClick={handleToggleMessage2} fullWidth variant="contained" color="primary">
          Ændre Billeder på Automater
          </Button>

          {/* change image message */}
          {showMessage2 && (
          <>
            <div>
              <ol>
                <li>Klik på "Rediger" i Begivenhedsoversigt.</li>
                <li>Marker det billede, du ønsker at aktivere.</li>
                <li>Vælg de automater, hvor billedet skal være aktivt på Automatlisten.</li>
                <li>Klik på "Gem Ændringer".</li>
                <li>Vælg, om du vil:
                  <ul>
                    <li>"Opdatere nu": Ændringer træder i kraft med det samme.</li>
                    <li>"Opdatere ved midnat": Ændringer træder i kraft efter natlig genstart.</li>
                  </ul>
                </li>
              <b>Bemærk:</b> En automat kan kun have ét aktivt pauseskærms- eller reklamebillede. Hvis du aktiverer et pauseskærmsbillede, vil det erstatte et aktivt reklamebillede.
              </ol>
            </div>
          </>
          )}
        </Grid>
        <Grid item xs={12}>
          {/* Deativate image Button */}
          <Button onClick={handleToggleMessage3} fullWidth variant="contained" color="primary">
          Deaktiver Billeder
          </Button>

          {/* Message Deativate image */}
          {showMessage3 && (
          <>
            <div>
              <ol>
                <li>Klik på "Rediger" i Begivenhedsoversigt.</li>
                <li>Marker det billede, du vil deaktivere.</li>
                <li>Fjern markeringen for de automater, hvor billedet ikke længere skal være aktivt på Automatlisten.</li>
                <li>Klik på "Gem Ændringer".</li>
                <b>Bemærk:</b> Du kan fjerne billedet fra alle automater ved at klikke på "Fravælg alle" og efterfølgende "Gem Ændringer".
              </ol>
            </div>
          </>
          )}
        </Grid>
        <Grid item xs={12}>
          {/* createdeviceevent Button */}
          <Button onClick={handleToggleMessage4} fullWidth variant="contained" color="primary">
          Opret En Automat Begivenhed
          </Button>

          {/* Message createdeviceevent */}
          {showMessage4 && (
          <>
            <div>
            <ol>
                <li>Klik på "Tilføj Automat Begivenhed".</li>
                <li>Udfyld følgende informationer:
                  <ul>
                    <li>Startdato og slutdato</li>
                    <li>Billede (vælg mellem "Ude af drift", "Pauseskærm", eller "Reklame")</li>
                    <li>Automater, hvor begivenheden skal være aktivt.</li>
                  </ul>
                </li>
                <li>Klik på "Fuldfør".</li>
                <b>Bemærk:</b> Ved et "Ude af drift" event, sættes automaten ikke automatisk ud af drift. Dette skal gøres via Mobilbasen.
              </ol>
              </div>
          </>
          )}
        </Grid>
        <Grid item xs={12}>
          {/* createslideshow Button */}
          <Button onClick={handleToggleMessage5} fullWidth variant="contained" color="primary">
          Opret Et Slideshow
          </Button>

          {/* Message createslideshow */}
          {showMessage5 && (
          <>
            <div>
              <ol>
            <li>Klik på "Rediger".</li>
                <li>Klik på "Opret Slideshow".</li>
                <li>Udfyld følgende informationer:
                  <ul>
                    <li>Varighed af hver billedfremvisning (10-60 sekunder)</li>
                    <li>Billedtype (Pauseskærm eller Reklame)</li>
                    <li>Billeder, der skal indgå i slideshowet</li>
                    <li>Automater, hvor slideshowet skal være aktivt.</li>
                  </ul>
                </li>
                <li>Klik på "Fuldfør".</li>
                </ol>
                <ol>
                  <b>Bemærk:</b>
                    <br />
                    Et slideshow kan kun indeholde billeder af én type (enten Pauseskærm eller Reklame).
                    <br />
                    En automat kan kun have ét slideshow aktivt ad gangen.
                    <br />
                    For at deaktivere et slideshow, skal de aktive billeder i slideshowet deaktiveres.  
                </ol>
                </div>
          </>
          )}
        </Grid>
      </Grid>
    </>
    );
  };

export default InfoDialogButtons;